import axiosInstance from "../api/axiosInstance";

export interface ChartSuggestion {
  chart_type: "bar" | "line" | "pie";
  x_axis: string;
  y_axis: string | string[]; 
  explanation: string;
}

export async function fetchChartSuggestion(
  headers: string[],
  rows: Record<string, any>[]
): Promise<ChartSuggestion> {
  const response = await axiosInstance.post("/generate-chart", {
    headers,
    rows,
  });

  return response.data as ChartSuggestion;
}
